module.exports = __webpack_public_path__ + "img/1449174233.dbef4959.jpg";